//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'hub',
  props: [
    'name', //名字
    'id', //蓝牙id号
    'buttonText', //按键的文字
    'desc', //描述，不可与按键共存
  ],
  data() {
    return {}
  },
  /*------------------------------------------- 开始运行 -------------------------------------------------------*/
  created() {

  },
  methods: {
    /*------------------------------------------- 绑定函数 -------------------------------------------------------*/
    /*  右侧按键点击
    * */
    btnClick() {
      this.$emit('buttonClick');
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/connect/zigbee/hub.vue